import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { getToken } from "../../storage/auth";
import { List } from "../../types/resquest";
import { MaterialType } from "../../types/materialType";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";
import { Combo } from "../../types/combo";

interface IList {
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
}

const entity = "materialTypes";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string,
  isCombo?: boolean
): {
  data: MaterialType[];
  meta: List;
  isLoading: boolean;
  combo: any[];
  error: Error;
} => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<MaterialType[]>([{} as MaterialType]);
  const [meta, setMeta] = useState<List>({} as List);
  const [error, setError] = useState<Error>({} as Error);
  const [combo, setCombo] = useState<Combo[]>();

  const render = () => {
    if (token) {
      if (isCombo === false || isCombo === undefined) {
        return "pagination";
      }
    }
  };

  useEffect(() => {
    if (render() === "pagination") {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
    setIsLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, token, isCombo]);

  useEffect(() => {
    if (token && isCombo === true) {
      setIsLoading(true);
      api
        .get(`/${entity}/getCombo`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const { data } = response;
          setCombo(data);
        })
        .catch(setError)
        .finally(() => setIsLoading(false));
    }
  }, [isCombo, params, token]);

  return { data, meta, isLoading, error, combo };
};

export const update = async (
  id: number | string,
  airport?: MaterialType
): Promise<MaterialType> => {
  const token = getToken();
  const { data } = await api.patch(`/${entity}/${id}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const token = getToken();
  const { data } = await api.get(`/${entity}/isInUse/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const deleteMaterialType = async (
  id: number | string
): Promise<MaterialType> => {
  const token = getToken();
  const { data } = await api.delete(`/${entity}/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const create = async (airport?: MaterialType): Promise<MaterialType> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const exportAll = async (params: any) => {
  let xlsxData = [
    { label: "Id", value: "ID_TIPO_MATERIAL" },
    { label: "Description", value: "DESCRICAO" },
    { label: "EDI Code", value: "CODIGO_EDI" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "MaterialType"});
};
